import { hooks as coreHooks } from 'mage-core';
import { selectors as stateSelectors } from 'mage-state';
import { useSelector } from 'react-redux';
export default function useUserAccessibleApps(clientIds) {
    const tokenHelper = coreHooks.useTokenHelper();
    const mpApps = useSelector(stateSelectors.getUserAccessibleApps);
    const apps = mpApps(tokenHelper);
    return apps.filter(app => clientIds.includes(app.clientId));
}
